var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('system-activity-base',{attrs:{"uri":_vm.uri,"campaigns-id":_vm.campaignsId,"campaigns-filter":_vm.campaignsFilter,"date-range":_vm.dateRange,"config-file":_vm.config,"tab":_vm.tab}})}
var staticRenderFns = []

export { render, staticRenderFns }